import { makeStyles } from 'tss-react/mui'

export const useStyle = makeStyles<{ pageName?: string }>()(
  (theme, { pageName }) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      height: theme.spacing(3.5),
      width: theme.spacing(3.5),
      borderRadius: theme.spacing(0.25),
      backgroundColor: theme.palette.bgSecondary.main,
      marginRight:
        pageName === 'Overview' ? theme.spacing(0) : theme.spacing(-1),
    },
    buttonIcon: {
      width: theme.spacing(2.75),
      height: theme.spacing(2.5),
      color: theme.palette.labraText.primary,
    },
    innerTabIcon: {
      width: theme.spacing(1.75),
      height: theme.spacing(1.75),
      color: theme.palette.labraText.primary,
    },
    sidePanelInfoContainer: {
      display: 'none',
    },
    sidePanelInfoHeaderIcon: {
      width: theme.spacing(3),
      height: theme.spacing(2.5),
      fontSize: '20px',
      color: theme.palette.labraText.primary,
    },
    sidePanelIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: theme.spacing(3.5),
      width: theme.spacing(3.875),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.bgSecondary.main,
    },
    sidePanelHeaderText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '22px',
      fontWeight: 400,
      color: theme.palette.labraText.primary,
      lineHeight: '28px',
      fontStyle: 'normal',
    },
    dotContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      bottom: '0',
      right: '0',
      width: theme.spacing(1.625),
      height: theme.spacing(1.625),
      backgroundColor: theme.palette.labraFormProgress.main,
      borderRadius: '50%',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: 500,
      color: theme.palette.labraText.primary,
      lineHeight: '24px',
      fontStyle: 'normal',
      letterSpacing: '0.15px',
    },
    mainTabContainer: {
      marginTop: theme.spacing(2.5),
    },
    mainTabContent: {
      marginTop: theme.spacing(2.5),
    },
    awsImage: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    cloudImage: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
    },
    cloudTabContent: {
      marginTop: theme.spacing(2.5),
    },
  })
)
